import React, { useEffect, useState, useRef } from 'react';

import { Grid, Row, Column } from 'uikit/grids';
import { Loading } from 'uikit/loaders';
import { ListEmpty, ScrollToTopButton } from '@/exceed';

import getCoverArtUrl from '../helpers/getCoverArtUrl';
import getVideoCardLink from '../helpers/getVideoCardLink';

import VideosCard from '../common/videosCard';
import VideosListItem from '../common/videosListItem';
import VideoBrowseCardMedia from './videoBrowseCardMedia';

import styles from '../styles/videoBrowseContent.module.scss';

function VideoBrowseContent({ view, browse, isLoading }) {
  const [isSkeletonLoading, setIsSkeletonLoading] = useState(isLoading);

  const scrollRef = useRef(null);

  const GridElement = view === 'tile' ? Grid : 'div';
  const RowElement = view === 'tile' ? Row : 'div';

  useEffect(() => {
    if (isLoading === false) {
      setIsSkeletonLoading(true);
      setTimeout(() => {
        setIsSkeletonLoading(false);
      }, 2000);
    }
  }, [isLoading]);

  if (isLoading) return <Loading className={styles.loader} />;

  if (browse?.length === 0) {
    return (
      <ListEmpty
        className={styles.empty}
        body="No videos or topics have been added to your organization."
        title="No videos added"
      />
    );
  }

  return (
    <div className={styles[`items_${view}`]} ref={scrollRef}>
      <GridElement>
        <RowElement
          sizes={{
            default: 1,
            small: 2,
            medium: 3,
            large: 4,
          }}
        >
          {!isLoading &&
            browse?.length > 0 &&
            browse.map((item) => {
              if (view === 'tile') {
                return (
                  <Column key={item.id}>
                    <VideosCard
                      isSkeletonLoading={isSkeletonLoading}
                      className={styles.item_card}
                      metaIcon="folder"
                      title={item.name}
                      image={getCoverArtUrl(item.cover_art)}
                      videoType={item.type}
                      reputation={item.metadata && item.metadata.reputation}
                      voteTotal={item.metadata && item.metadata.vote_total}
                      link={getVideoCardLink({ id: item.id, type: item.type })}
                      duration={item.metadata && item.metadata.duration}
                      progress={item.enrollment_metadata?.progress}
                      isComplete={item.enrollment_metadata?.is_complete}
                      cardMedia={
                        <VideoBrowseCardMedia
                          type={item.type}
                          duration={item.metadata && item.metadata.duration}
                          isComplete={item.enrollment_metadata?.is_complete}
                        />
                      }
                    />
                  </Column>
                );
              }
              return (
                <div key={item.id}>
                  <VideosListItem
                    title={item.name}
                    description={item.description}
                    image={getCoverArtUrl(item.cover_art)}
                    videoType={item.type}
                    duration={item?.metadata?.duration}
                    voteTotal={item?.metadata?.vote_total}
                    reputation={item.metadata && item.metadata.reputation}
                    link={getVideoCardLink({ id: item.id, type: item.type })}
                    isComplete={item.enrollment_metadata?.is_complete}
                  />
                </div>
              );
            })}
        </RowElement>
      </GridElement>
      {!isLoading && browse?.length > 0 && (
        <ScrollToTopButton className={styles.scrollToTop} container={scrollRef.current} />
      )}
    </div>
  );
}

export default VideoBrowseContent;
